<template>
  <div>
    <div class="vx-row mt-4">
      <!-- Ressarcimento -->
      <div class="vx-col sm:w-1/4 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Ressarcimento</label>
        <vs-switch
          v-model="formAnalise.analise.ressarcimento"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Passível de Negativa -->
      <div class="vx-col sm:w-1/4 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Passível de Negativa</label>
        <vs-switch
          v-model="formAnalise.analise.passivelNegativa"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- CNH Vencida -->
      <div class="vx-col sm:w-1/4 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">CNH Vencida</label>
        <vs-switch
          v-model="formAnalise.analise.cnhVencida"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- EAR -->
      <div class="vx-col sm:w-1/4 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">EAR</label>
        <vs-switch
          v-model="formAnalise.analise.ear"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Data Vencimento CNH -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label for class="vs-input--label">Data Vencimento CNH</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="formCondutor.dadosPessoaisCondutor.dataVencimentoCnh"
            placeholder="DD/MM/AAAA"
            name="Data Vencimento CNH"
          />
        </div>
      </div>

      <!-- Categoria da CNH -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-select--label">Categoria da CNH</label>
        <v-select
          :multiple="true"
          class="selectStyle"
          :options="listCategoriaCNH"
          name="Categoria da CNH"
          id="Categoria da CNH"
          v-model="formCondutor.dadosPessoaisCondutor.categoriaCnh"
          :reduce="(item) => item.label"
        ></v-select>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Possui Tacógrafo -->
      <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Possui Tacógrafo</label>
        <vs-switch
          v-model="formAnalise.analise.posuiTacografo"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Possui Rastreador -->
      <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Possui Rastreador</label>
        <vs-switch
          v-model="formAnalise.analise.rastreador"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Contato com Assistência? -->
      <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Contato com Assistência?</label>
        <vs-switch
          v-model="formAnalise.contatoAssistencia"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Data Contato Assistência -->
      <div class="vx-col sm:w-1/2 xl:w-3/12 w-full mb-2">
        <label class="vs-input--label">Data Contato Assistência</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="formAnalise.dataContatoAssistencia"
            placeholder="DD/MM/AAAA"
            name="Data de Contato da Assistência"
            :disabled="!formAnalise.contatoAssistencia"
          />
        </div>
      </div>

      <!-- Hora Contato Assistência -->
      <div class="vx-col sm:w-1/2 xl:w-3/12 w-full mb-2">
        <label class="vs-input--label">Hora Contato Assistência</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePickerHour"
            v-model="formAnalise.horaContatoAssistencia"
            placeholder="HH:MM"
            name="Hora de Contato da Assistência"
            :disabled="!formAnalise.contatoAssistencia"
          />
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Atendimento Segurado -->
      <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Atendimento Segurado</label>
        <vs-switch
          v-model="formAnalise.analise.atendimentoAssociado"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Atendimento Terceiro -->
      <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Atendimento Terceiro</label>
        <vs-switch
          v-model="formAnalise.analise.atendimentoTerceiro"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Atendimento Somente Terceiro -->
      <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Atendimento Somente Terceiro</label>
        <vs-switch
          v-model="formAnalise.analise.atendimentoSomenteTerceiro"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Analista Responsável -->
      <div class="vx-col xl:w-1/2 w-full mb-2">
        <label for="" class="vs-select--label"
          >Analista Responsável - Análise</label
        >
        <v-select
          :options="listUsuarios"
          name="Analista"
          id="Analista"
          v-model="formAnalise.analise.idUsuarioAnalise"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import vSelect from 'vue-select';

import { condutor } from './../../shared/forms';
import { LIST_CATEGORIAS_CNH } from './../../shared/const';

export default {
  props: ['formData', 'dominios'],
  components: {
    flatPickr,
    vSelect,
  },
  watch: {
    formData(value) {
      if (!value.dadosAnalise) {
        console.error('ERRO NO CONTRATO DO OBJETO - EVENTOS ANALISE FORM');
        return;
      }

      if (!value.condutor) {
        console.error('ERRO NO CONTRATO DO OBJETO - EVENTOS ANALISE FORM');
        return;
      }

      this.formAnalise = Object.assign(this.formAnalise, value.dadosAnalise);

      this.formCondutor = Object.assign(this.formCondutor, value.condutor);

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.dadosAnalise = this.formAnalise;

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.condutor = this.formCondutor;
    },
  },
  data() {
    return {
      formAnalise: {
        analise: {
          ressarcimento: null,
          passivelNegativa: null,
          cnhVencida: null,
          ear: null,
          posuiTacografo: null,
          rastreador: null,
          atendimentoAssociado: null,
          atendimentoTerceiro: null,
          atendimentoSomenteTerceiro: null,
          idUsuarioAnalise: null,
        },
        dataContatoAssistencia: null,
        horaContatoAssistencia: null,
        contatoAssistencia: null,
      },
      formCondutor: { ...condutor },

      listCategoriaCNH: LIST_CATEGORIAS_CNH,
      listUsuarios: [],

      // Configurações de Component
      configdateTimePicker: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configdateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
    };
  },
  mounted() {
    if (!this.formData.dadosAnalise) {
      console.error('ERRO NO CONTRATO DO OBJETO - EVENTOS ANALISE FORM');
      return;
    }

    if (!this.formData.condutor) {
      console.error('ERRO NO CONTRATO DO OBJETO - EVENTOS ANALISE FORM');
      return;
    }

    this.formAnalise = Object.assign(
      this.formAnalise,
      this.formData.dadosAnalise,
    );

    this.formCondutor = Object.assign(
      this.formCondutor,
      this.formData.condutor,
    );

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.dadosAnalise = this.formAnalise;

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.condutor = this.formCondutor;

    if (this.dominios) {
      this.listUsuarios = this.dominios.listUsuarios;
    }
  },
};
</script>

<style scoped>
.selectStyle {
  font-size: 1rem !important;
}

.vdp-datepicker input {
  width: 100%;
}
input.flatpickr-input {
  width: 100%;
}
</style>
